if (!customElements.get("td-discount-badge")) {
    class TDDiscountBadge extends HTMLElement {
        constructor() {
            super();
            this.DISCOUNT_MESSAGE_CLASS = '.td-discount-badge';

            this.discount = this.querySelector(this.DISCOUNT_MESSAGE_CLASS);
        }
    
        connectedCallback() {
            document.addEventListener('variant:change', ({detail}) => this.updateBadge(detail))
        }

        updateBadge(detail) {
            let comparePrice = detail.variant.compare_at_price
            let price = detail.variant.price
            if (comparePrice && price) {
                if (comparePrice > price) {
                    this.discount.classList.remove('td-discount-badge--hide');
                    this.discount.textContent = `-${Math.floor((comparePrice - price) / comparePrice * 100)}%`
                } else {
                    this.discount.classList.add('td-discount-badge--hide');
                }
            }
        }
    }

    customElements.define("td-discount-badge", TDDiscountBadge);
}